import moment from 'moment';
import { TDateObject } from '../types';

export const DATE_RANGES: TDateObject = {
    today: {
        gte: moment().startOf('day').format(),
        lte: moment().endOf('day').format(),
    },
    yesterday: {
        gte: moment().subtract('1', 'days').startOf('day').format(),
        lte: moment().subtract('1', 'days').endOf('day').format(),
    },
    month: {
        gte: moment().startOf('month').format(),
        lte: moment().endOf('month').format(),
    },
    pastMonth: {
        gte: moment().subtract(1, 'month').startOf('month').format(),
        lte: moment().subtract(1, 'month').endOf('month').format(),
    },
    year: {
        gte: moment().startOf('year').format(),
        lte: moment().endOf('year').format(),
    },
    pastYear: {
        gte: moment().subtract(1, 'years').startOf('year').format(),
        lte: moment().subtract(1, 'years').endOf('year').format(),
    },
};
